import React, { useEffect } from 'react';
import { Button, Form } from 'antd';
import Drawer from '../../../../components/AppDrawer';
import ContactCategoryForm, { type ContactCategoryFormFieldValues } from './ContactCategoryForm';
import type { ContactCategoryDetail, ContactCategoryFormValues } from '../types';

export interface ContactCategoryFormDrawerProps {
  open: boolean;
  onClose: () => void;
  mode: 'add' | 'edit';
  contactCategory: ContactCategoryDetail | null | undefined;
  loadingContactCategory: boolean;
  onSave: (values: ContactCategoryFormValues) => void;
  saving: boolean;
}

const ContactCategoryFormDrawer: React.FC<ContactCategoryFormDrawerProps> = ({
  open,
  onClose,
  mode,
  contactCategory,
  loadingContactCategory,
  onSave,
  saving,
}) => {
  const [form] = Form.useForm<ContactCategoryFormFieldValues>();

  useEffect(() => {
    if (!open) return;
    if (mode === 'add') {
      form.resetFields();
      form.setFieldsValue({ isActive: true, sortOrder: 0 });
    }
  }, [open, mode, form]);

  const title = mode === 'add' ? 'Add contact category' : 'Edit contact category';

  return (
    <Drawer
      title={title}
      destroyOnClose
      size="large"
      placement="right"
      open={open}
      onClose={onClose}
      footer={
        <div style={{ textAlign: 'right' }}>
          <Button onClick={onClose} style={{ marginRight: 8 }}>
            Cancel
          </Button>
          <Button type="primary" loading={saving} onClick={() => form.submit()}>
            Save
          </Button>
        </div>
      }
    >
      {(mode === 'add' || !loadingContactCategory) && (
        <ContactCategoryForm
          form={form}
          mode={mode}
          initialValues={mode === 'edit' ? contactCategory ?? null : null}
          onFinish={onSave}
        />
      )}
    </Drawer>
  );
};

export default ContactCategoryFormDrawer;
